import { Block } from '@contentful/rich-text-types'

// This is for cases where the heading might be partially underlined and have two child nodes
// so you can't just get the text (.value) from the first one in the array
export function getTextFromBlock(contentNode: Block['content']) {
  return contentNode.reduce((acc, current) => {
    return 'value' in current ? acc + current.value : ''
  }, '')
}
